const GOODSIN_ADMIN = '/goodsin-admin';
const PURCHASE_ORDERS = `${GOODSIN_ADMIN}/purchase-orders`;

export const GET_PURCHASE_ORDERS = `${PURCHASE_ORDERS}/getPurchaseOrders`;
export const GET_PURCHASE_ORDER = `${PURCHASE_ORDERS}/getPurchaseOrder`;
export const GET_PO_IMAGES = `${PURCHASE_ORDERS}/getPoImages`;
export const UPLOAD_PO_IMAGES = `${PURCHASE_ORDERS}/uploadPoImages`;